import React, { useEffect, useState } from "react";
import { Box, CardMedia, Grid, Typography } from "@mui/material";
import { db } from "../../../firebase/firebaseConfig";
import { collection, onSnapshot } from 'firebase/firestore';

const CardFeatures = () => {
    const [cardFeatures, setCardFeatures] = useState([]);

    const truncateText = (text, maxLength = 500) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    }

    useEffect(() => {
        onSnapshot(collection(db, 'tarjetacaracteristicaproductocalocho'),
            (snapshot) => {
                const arregloCardFeatures = snapshot.docs.map((docCardFeatures) => {
                    return {...docCardFeatures.data(), id: docCardFeatures.id};
                })
    
                setCardFeatures(arregloCardFeatures);
              },
              (error) => {
                  console.log(error);
              }
          );
    }, []);  

    return (
        <Grid container spacing={3} justifyContent="center">
            {cardFeatures.map((cardfeatures) => (
                <Grid item xs={12} sm={10} md={8} key={cardfeatures.id}>
                    <Box
                        sx={{
                            textAlign: 'center',
                            padding: { xs: '10px', md: '20px' },  // Ajuste de padding para responsividad
                            border: '1px solid rgba(255, 255, 255, 0.1)', 
                            borderRadius: '8px',
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            width: { xs: '90%', sm: '80%', md: '100%' },  // Ancho adaptable
                            margin: '10px auto',
                            '&:hover': { opacity: 0.9 },
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.opacity = 0.9)}
                        onMouseOut={(e) => (e.currentTarget.style.opacity = 1)}
                    >
                        <CardMedia 
                            component="img"
                            sx={{
                                width: { xs: '100%', sm: '80%', md: '100%' },
                                height: 'auto',
                                borderRadius: '5%', 
                                border: '1.5px solid #f1f1f1',
                                margin: '0 auto', 
                            }}
                            image={cardfeatures.imagen}
                            alt={cardfeatures.titulo}
                        />
                        <Typography 
                            variant="h6" 
                            sx={{ 
                                fontWeight: 'bold', 
                                width: 'auto',
                                alignItems: 'center',
                                textAlign: 'center',
                                '@media (max-width: 600px)': {  // Ajustes para móviles
                                    fontSize: '1.1rem',  // Tamaño más pequeño para la tipografía
                                    margin: '1% 5%',
                                },
                            }}
                        >
                            {cardfeatures.titulo}
                        </Typography>
                        <Typography variant="subtitle2">
                            <span>{truncateText(cardfeatures.descripcion)}</span>
                        </Typography>
                    </Box>
                </Grid>
            ))}
        </Grid>
    );
}

export default CardFeatures;
